module.exports = __webpack_public_path__ + "static/img/press9.9929efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press9.png
// module id = Koy0
// module chunks = 0